// extracted by mini-css-extract-plugin
module.exports = {"submit":"_6c97079b1b--submit--Pqe3o"};